import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetch } from "@/utils/common";
import { changeState } from "@/store/data/global";
import { localizePath } from "@/utils/locale";
import { getSolutionBanner } from "@/utils/solutionBanners";

export const zhNavListDefs = [
  {
    key: "ai-server",
    category: "AI服务器",
    children: [],
  },
  {
    key: "solution",
    category: "解决方案",
    children: [],
  },
  {
    key: "news",
    category: "新闻中心",
    children: [{ path: "/news", id: 1, name: "公司新闻" }],
  },
  {
    key: "services",
    category: "公司业务",
    children: [
      { path: "/services", id: 1, name: "生产制造" },
      { path: "/services", id: 2, name: "供应链服务" },
      { path: "/services", id: 3, name: "售后与运维" },
      { path: "/services", id: 4, name: "利旧改配服务" },
      { path: "/services", id: 5, name: "设计研发中心" },
    ],
  },
  {
    key: "about",
    category: "关于信维",
    children: [
      { path: "/about", id: 1, name: "公司简介" },
      { path: "/about", id: 5, name: "视频展示" },
      { path: "/about", id: 3, name: "荣誉资质" },
      { path: "/about", id: 2, name: "联系我们" },
    ],
  },
];

export const enNavListDefs = [
  {
    key: "home",
    category: "Home",
    path: "/",
    children: [],
  },
  {
    key: "solution",
    category: "Solutions",
    path: "/solution",
    children: [],
  },
  {
    key: "services",
    category: "Services",
    path: "/services",
    children: [],
  },
  {
    key: "about",
    category: "About Us",
    path: "/about",
    children: [],
  },
];

export const useFooterNav = (isEnglish, locale) => {
  const baseDefs = isEnglish ? enNavListDefs : zhNavListDefs;
  const [navList, setNavList] = useState(baseDefs);
  const dispatch = useDispatch();

  const localizeChildren = useCallback(
    (item) => ({
      ...item,
      path: item.path ? localizePath(item.path, locale) : undefined,
      children: (item.children ?? []).map((child) => ({
        ...child,
        path: localizePath(child.path, locale),
      })),
    }),
    [locale]
  );

  useEffect(() => {
    setNavList(isEnglish ? enNavListDefs : zhNavListDefs);
  }, [isEnglish]);

  const getSolutionCate = useCallback(async () => {
    try {
      const solutionRes = await fetch({
        url: "/type/get_list",
        method: "post",
        data: { data: { type: 4 } },
      });
      const msg_list = solutionRes?.msg_list ?? [];
      const list = msg_list.map((val) => ({
        ...val,
        name: val.typeName,
        path: localizePath("/solution", locale),
        id: val.typeId,
        label: val.typeName,
        iconUrl: getSolutionBanner(val.typeName),
      }));

      const productRes = await fetch({ url: "/type/get_list/5" });
      const productCates = productRes?.msg_list ?? [];
      const productCatesList = productCates.map((val) => ({
        path: localizePath("/AIServer#product-category", locale),
        id: val.typeId,
        name: val.typeName,
      }));

      dispatch(changeState({ solutionCates: list }));

      if (isEnglish) {
        return;
      }

      const updatedNavList = baseDefs.map((item) => {
        if (item.key === "ai-server") {
          return { ...item, children: productCatesList };
        }
        if (item.key === "solution") {
          return localizeChildren({ ...item, children: list });
        }
        return localizeChildren(item);
      });
      setNavList(updatedNavList);
    } catch (error) {
      console.error("获取底部导航数据失败:", error);
      if (!isEnglish) {
        setNavList(baseDefs.map(localizeChildren));
      }
    }
  }, [baseDefs, dispatch, isEnglish, locale, localizeChildren]);

  const getContactInfo = useCallback(async () => {
    try {
      const response = await fetch({ url: "/contact_us/detail" });
      dispatch(changeState({ contactInfo: response }));
    } catch (error) {
      console.error("获取联系信息失败:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    getSolutionCate();
    getContactInfo();
  }, [getSolutionCate, getContactInfo]);

  return { navList };
};
